import React from "react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { useT } from "@/context/LanguageContext";
import { Icon } from "@/components/common/Icon";
import { HOW_IT_WORKS } from "@/data/site";

export function HowItWorks() {
  const { t } = useT();
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          overline="How it works"
          title="From inquiry to delivery in four steps"
          subtitle="A transparent, managed process that keeps you informed at every milestone."
        />
        <div className="relative mt-16">
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-[#1E73BE] to-[#16B894] lg:block" />
          <div className="grid gap-10 lg:grid-cols-4 lg:gap-6">
            {HOW_IT_WORKS.map((s, i) => (
              <Reveal key={s.step} delay={i * 0.12}>
                <div className="relative" data-testid={`how-step-${i}`}>
                  <div className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full border-4 border-white bg-gradient-to-br from-[#1E73BE] to-[#16B894] text-white shadow-md">
                    <Icon name={s.icon} size={24} weight="duotone" />
                  </div>
                  <p className="mt-5 font-mono text-xs font-semibold text-teal">STEP {s.step}</p>
                  <h3 className="mt-1 font-heading text-lg font-semibold text-ink">{t(`how.${s.key}.title`)}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{t(`how.${s.key}.desc`)}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
